import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import injectSaga from 'utils/injectSaga';
import { translateData } from 'utils/translation';
import { selectLandingData } from 'containers/Landing/selectors';
import landingSaga from 'containers/Landing/saga';
import Header from 'components/ContentfulFields/Header';
import Footer from 'components/ContentfulFields/Footer';
import { SkipToMainContent } from 'components/Ui/ScreenReader';
import { LANDING_PAGE_KEY } from 'containers/Landing/constants';

const BaseLayout = ({ name, children }) => {
  const site = useSelector(selectLandingData());

  const { header, footer } = site?.components;

  return (
    <>
      <SkipToMainContent>
        <a className="skip" href="#main-content">
          {translateData('Skip To Main Content')}
        </a>
      </SkipToMainContent>
      {header && <Header document={header} />}
      <main id="main-content" data-tracking={name}>
        {children}
      </main>
      {footer && <Footer document={footer} />}
    </>
  );
};

BaseLayout.propTypes = {
  name: PropTypes.string,
  children: PropTypes.object,
};

const withLandingSaga = injectSaga({
  key: LANDING_PAGE_KEY,
  saga: landingSaga,
});

export default withLandingSaga(BaseLayout);
